import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import internalAPI from '../../../services/internalAPI';
import { RootState } from '../../configureStore';
import { Bookmark } from './bookmarkSlice';

type GetBookmarksOptions = {
  force?: boolean;
};

export const getBookmarks = createAsyncThunk<
  { [entityUuid: string]: Bookmark },
  GetBookmarksOptions | undefined,
  { state: RootState }
>(
  'bookmark/get',
  async (_, { rejectWithValue }) => {
    try {
      const response = await internalAPI(true).get('/api/bookmark');
      if (response.status == 200 && response.data) {
        return response.data;
      } else {
        return rejectWithValue({ error: 'Unable to retrieve bookmarks' });
      }
    } catch (e) {
      const err = e as AxiosError;
      console.debug('Bookmark fetch failed', err.response?.status);
      return rejectWithValue({ error: 'Unable to retrieve bookmarks' });
    }
  },
  {
    condition: (options, { getState }) => {
      const { bookmarkInfo } = getState();
      if (!options?.force && bookmarkInfo.status !== 'idle') {
        return false;
      }
    }
  }
);
